import axios from "axios";
import { getXRFHeaderValue } from "../utils/getXRFHeaderValue";
import ItemDataParser from "./ItemDataParser";

class ItemService {
  getItemData(itemid) {

    const getItemUrl = `/sitecore/api/ssc/item/${itemid}?IncludeStandardTemplateFields=true`;
    const options = {
      headers: {
        "content-type": "application/json",
        "X-RequestVerificationToken": getXRFHeaderValue(),
        "X-Requested-With": "XMLHttpRequest"
      },
      withCredentials: true
    };
    return axios
      .get(getItemUrl, options)
      .then(res => ItemDataParser.mapContentItemToResult(res.data))
      .catch(error => { });
  }

  getItemDataByPath(path) {
    let pagePath = ItemDataParser.fixItemPath(path);
    let getItemUrl = `/sitecore/api/ssc/item/?path=${pagePath}&IncludeStandardTemplateFields=true`;

    const options = {
      headers: {
        "content-type": "application/json",
        "X-RequestVerificationToken": getXRFHeaderValue(),
        "X-Requested-With": "XMLHttpRequest"
      },
      withCredentials: true
    };
    return axios
      .get(getItemUrl, options)
      .then(res => ItemDataParser.mapContentItemToResult(res.data))
      .catch(error => { });
  }

  // TODO: using dev version for demo/troubleshooting
  getItemVersionHistory(itemid) {
    return axios
      .get('/sitecore/shell/client/Applications/altola/insights/data/item-versions.json')
      .then(result => ItemDataParser.createChangeHistory(result.data))
      .catch(error => { });
  }
}

export default new ItemService();



// WEBPACK FOOTER //
// ./src/data/ItemService.prod.js